import React from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { setAddGlossaryOpen } from '../../../redux/slices/wikiSlice';
import AddGlossaryPopup from './AddGlossaryPopup';

const AddGlossary = ({ onSearchChanged }) => {
  const dispatch = useDispatch();

  return (
    <Wrapper>
      <AddGlossaryPopup onSearchChanged={onSearchChanged} />
      <RowWrapper>
        <Button1>
          <Button color="primary" variant="contained" onClick={() => dispatch(setAddGlossaryOpen(true))}>
            Add Glossary
          </Button>
        </Button1>
      </RowWrapper>
    </Wrapper>
  );
};

export default AddGlossary;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const RowWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin: 0 0 16px;
`;

const Button1 = styled.div`
  button {
    min-width: 180px;
    height: 40px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: 0.01em;
  }
`;
